/* @flow */
/*jshint esversion: 6 */
import React, { Component } from "react";
import "../../App.css";
import GenericTable from "../../components/GenericTable";
import LangContext from "../../contextProvider/LangContext";
import { Input, InputNumber } from "antd";
import TableLineIcons from "../../components/TableLineIcons";
import GenericSelector from "../../components/GenericSelector";


class SoftwareVersion extends Component {
    constructor(props: Props) {
        super(props);
        this.state = {

        };

        this.id = "SOFTWARE_VERSION";

        this.api = {
            get: "get_software_version",
            create: "create_software_version",
            edit: "edit_software_version",
        }

        this.selectors = [
            { id: "DB_VERSIONS_LIST", api: "db_versions_list" }
        ]

        if (props.data[this.id] === undefined) props.data[this.id] = { ...props.data.genericData };
        this.selectors.forEach(x => {
            if (props.data[x.id] === undefined) props.data[x.id] = { ...props.data.genericSelector };
        })
    }

    static contextType = LangContext;

    getText = (id) => {
        return this.context.get(id) || '[' + id + ']'
    }

    componentDidMount() {
        this.props.dataActions.genericSelectorRefreshDataset(
            "DB_VERSIONS_LIST", this.props.user.companyCode, this.props.user.token, "db_versions_list");
    }

    componentDidUpdate() {
        document.title = "Cash On Tab - " + this.getText(22606);
    }

    render() {
        const gt = this.getText;

        const divStyle = {
            align: "center",
            dir: "rtl",
            padding: "2% 2% 2% 2%",
            maxWidth: 800,
            margin: "auto"
        };

        const { editedRecord, editing } = this.props.data[this.id]

        const renderName = (text, record) => {
            if (record.key != editing) return text;
            return (<InputNumber
                value={editedRecord.nName}
                onChange={e => { this.props.dataActions.genericDataSetEdit(this.id, { nName: e }) }}
            />)
        };

        const renderDesc = (text, record) => {
            if (record.key != editing) return text;
            return (<Input
                value={editedRecord.nDesc}
                onChange={e => { this.props.dataActions.genericDataSetEdit(this.id, { nDesc: e.target.value }) }}
            />)
        };

        const renderDBVersion = (text, record) => {
            if (record.key != editing) return text;
             return (<GenericSelector
                {...this.props}
                id="DB_VERSIONS_LIST"
                value={editedRecord.nDBVersionID}
                onChange={e => { this.props.dataActions.genericDataSetEdit(this.id, { nDBVersionID: e }) }}
            />)
        };

        const renderEdit = (text, record) => {
            if (editing == record.key) {
                return (<TableLineIcons
                    onCheck={() => {
                        this.props.dataActions.genericDataSaveEdit(
                            this.id, this.props.user.companyCode, this.props.user.token,
                            (editing == 0) ? this.api.create : this.api.edit,
                            this.api.get)
                    }}
                    onClose={() => {
                        if (editing == 0) this.props.dataActions.genericDataCancelInlineCreate(this.id)
                        else this.props.dataActions.genericDataCancelEditing(this.id)
                    }}
                />)
            } else {
                return (<TableLineIcons
                    onEdit={() => { this.props.dataActions.genericDataStartEditing(this.id, record.key, record.index) }}
                />)
            }
        }

        return (<div style={divStyle}>
            <GenericTable
                {...this.props}
                id={this.id}
                getApi={this.api.get}
                title={gt(22606)}
                addButton={() => { this.props.dataActions.genericDataStartInlineCreate(this.id) }}
                searchBox
                filterDatasetText={this.state.valueSearch}
                valueSearch={this.state.valueSearch}
                onChangeSearch={value => this.setState({ valueSearch: value.target.value })}
                columns={[
                    { title: gt(22607), key: "nName", dataIndex: "nName", width: "10%", render: renderName },
                    { title: gt(22608), key: "nDesc", dataIndex: "nDesc", width: "40%", render: renderDesc },
                    { title: gt(22609), key: "nDBVersionID", dataIndex: "nDBVersionID", width: "40%", render: renderDBVersion },
                    { title: gt(22610), width: "10%", render: renderEdit },
                ]}
            />
        </div>)
    }

}

export default SoftwareVersion;